// extracted by mini-css-extract-plugin
module.exports = {"content__loader":"style_content__loader__3SecW","contentLoaderAnimation":"style_contentLoaderAnimation__1Rb_j"};